import {
  useHasMoreChatElements,
  useIsLoadingMoreChatElements,
} from "../../../view_stores/chat_messages/useChatMessagesStore";

export default function ProjectChatLoadingMoreIndicator() {
  const isLoadingMore = useIsLoadingMoreChatElements();
  const hasMore = useHasMoreChatElements();

  // If everything is loaded, don't render the placeholder at all
  if (!hasMore) return null;

  return (
    <div className="flex justify-center px-2 py-1 min-h-[18px]">
      {isLoadingMore ? (
        <div className="flex items-end gap-1.5">
          <LoadingDot className="animate-[pulse_1.5s_ease-in-out_infinite_0ms]" />
          <LoadingDot className="animate-[pulse_1.5s_ease-in-out_infinite_150ms]" />
          <LoadingDot className="animate-[pulse_1.5s_ease-in-out_infinite_300ms]" />
        </div>
      ) : null}
    </div>
  );
}

function LoadingDot({ className }: { className: string }) {
  return (
    <div className={`w-1.5 h-1.5 rounded-full bg-[#E91E63] ${className}`} />
  );
}
